import { createReducer, on } from '@ngrx/store';

import * as tokenAction from '../actions/tokens.actions';
import { ActiveTokensInitialState } from '../states';

export const ACTIVE_TOKENS_REDUCER_KEY = 'tokens';
export const ACTIVE_TOKENS_REDUCER = createReducer(
    ActiveTokensInitialState,
    on(tokenAction.InvalidateTokensSuccess, (state, action) => {
        return {
            ...state,
            invalidate: {
                success: action.msg,
                error: undefined,
            },
        };
    }),
    on(tokenAction.ClearInvalidatedToken, state => {
        return {
            ...state,
            invalidate: {
                success: undefined,
                error: undefined,
            },
        };
    }),
    on(tokenAction.InvalidateTokensFailed, (state, action) => {
        return {
            ...state,
            invalidate: {
                success: undefined,
                error: action.msg,
            },
        };
    })
);
